import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
export var ClickType;
(function (ClickType) {
    ClickType["Click"] = "CLICK";
    ClickType["Lead"] = "LEAD";
    ClickType["Ftd"] = "FTD";
    ClickType["ValidationFailed"] = "VALIDATION_FAILED";
    ClickType["RegistrationFailed"] = "REGISTRATION_FAILED";
})(ClickType || (ClickType = {}));
export const ClickTypeMap = new Map([
    [ClickType.Click, 'Global.Options.Click'],
    [ClickType.Lead, 'Global.Options.Lead'],
    [ClickType.Ftd, 'Global.Options.FTD'],
    [ClickType.ValidationFailed, 'Global.Options.ValidationFailed'],
    [ClickType.RegistrationFailed, 'Global.Options.RegistrationFailed'],
]);
let ClickTypeService = class ClickTypeService {
    constructor(_translate) {
        this._translate = _translate;
        this._data = ClickTypeMap;
    }
    list() {
        return this._data;
    }
    get(key) {
        const k = this._data.get(key);
        return k ? this._translate.instant(k) : k;
    }
};
ClickTypeService.ctorParameters = () => [
    { type: TranslateService }
];
ClickTypeService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [TranslateService])
], ClickTypeService);
export { ClickTypeService };
